import { FC } from 'react';
import { MdDeleteForever } from 'react-icons/md';
import { ActionsIcon } from '../../../../../../assets/svg/actions';
import { Collapse } from '../../../../../../components/collapse/collapse';
import { IconButton } from '../../../../../../components/icon-button/icon-button';
import { HasAccess } from '../../../../../../features/has-access/has-access';
import { Tooltip } from '../../../../../../features/tooltip/tooltip';
import s from './roles-dictionary-grouped.module.css';
import {
  RolesDictionaryGroupedProps,
  useRolesDictionaryGrouped,
} from './use-roles-dictionary-grouped';

export const RolesDictionaryGrouped: FC<RolesDictionaryGroupedProps> = (props) => {
  const { role, isSystem } = props;

  const {
    collapse,
    count,
    getLocale,
    handleDeleteRole,
    handleEditRole,
    setTooltip,
    t,
    toggleCollapse,
    tooltip,
    unattachRoleModal,
  } = useRolesDictionaryGrouped(props);

  return (
    <Collapse
      wrapperClassname={s.feature}
      withArrow
      headerClassName={s.trigger}
      open={collapse}
      onClickHeader={toggleCollapse}
      header={
        <>
          <span className={s.name}>{role.name}</span>
          <span className={s.counter}>{`(${count} ${t('сотрудник', { count })})`}</span>
          <HasAccess service="staff" permissions={['write']}>
            <Tooltip
              wrapperClassName={s.tooltip}
              trigger={<ActionsIcon />}
              open={tooltip}
              onOpen={setTooltip}
              onClickTrigger={(e) => e.stopPropagation()}
            >
              <ul className={s.list}>
                <li className={s.item} onClick={handleEditRole}>
                  {t('Редактировать')}
                </li>
                {!isSystem && (
                  <li className={s.item} onClick={handleDeleteRole}>
                    {t('Удалить')}
                  </li>
                )}
              </ul>
            </Tooltip>
          </HasAccess>
        </>
      }
      motionKey={role.id}
      key={role.id}
    >
      <ul className={s.employees}>
        {role.employees?.map((item) => (
          <li key={item.id} className={s.item}>
            {getLocale(item.name)} {getLocale(item.surname)}
            {/* {`(${item.places?.map((place) => getLocale(place.value)).join(', ')})`} */}
            <HasAccess service="staff" permissions={['write']}>
              <IconButton
                variant="ghost"
                tooltip={t('Удалить')}
                onClick={() =>
                  unattachRoleModal.handleOpenModal({ employeeId: item.id, roleId: role.id })
                }
              >
                <MdDeleteForever />
              </IconButton>
            </HasAccess>
          </li>
        ))}
      </ul>
    </Collapse>
  );
};
